import * as fetch from 'isomorphic-fetch';
import * as Promise from 'es6-promise';
import { uniq, flatMap, find, findLast } from 'lodash';
import { ActionType, ActionTypes } from '../../actions/index';
import { IAppState } from '../../reducers/index';
import { fetchSeatMatches } from './filter-fetch';
import { ISeatMatchRequestModel } from '../../classes/request-model';

export function clearPriceRange(minPrice: number, maxPrice: number) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.PRICE_RANGE_CLEAR, value: { minPrice: minPrice, maxPrice: maxPrice } });
        dispatch(fetchSeatMatches());
    }
}

export function selectMinPrice(minPrice: number) {
    return (dispatch, state) => {
        let didPricePointChange = findPriceRange(state, minPrice, false);

        dispatch({ type: ActionTypes.SELECT_MIN_PRICE, value: minPrice });

        if (didPricePointChange) {
            dispatch(fetchSeatMatches());
        }
    };
}

export function selectMaxPrice(maxPrice: number) {
    return (dispatch, state) => {
        let didPricePointChange = findPriceRange(state, maxPrice, true);

        dispatch({ type: ActionTypes.SELECT_MAX_PRICE, value: maxPrice });

        if (didPricePointChange) {
            dispatch(fetchSeatMatches());
        }
    };
}

function findPriceRange(state, newPrice: number, isMaxPrice: boolean) {
    let currentState: IAppState = state();

    let uniquePrices = uniq(flatMap(currentState.appSettingsModel.priceTypeSettings, pt => { return pt.prices }));
    let sortedPrices = uniquePrices.sort((a, b) => { return a - b });

    if (isMaxPrice) {
        const lastMaxPricePoint = find(sortedPrices, price => { return price >= currentState.priceRangeModel.maxPrice });
        const currentMaxPricePoint = find(sortedPrices, price => { return price >= newPrice });

        if (lastMaxPricePoint === currentMaxPricePoint) {
            return false;
        }
    } else {
        const lastMinPricePoint = findLast(sortedPrices, price => { return price < currentState.priceRangeModel.minPrice });
        const currentMinPricePoint = findLast(sortedPrices, price => { return price < newPrice });

        if (lastMinPricePoint === currentMinPricePoint) {
            return false;
        }
    }

    return true;
}